import * as i0 from "@angular/core";
export class PlayerInfoStore {
}
PlayerInfoStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlayerInfoStore_Factory() { return new PlayerInfoStore(); }, token: PlayerInfoStore, providedIn: "root" });
export var PlayerInfoStoreKeys;
(function (PlayerInfoStoreKeys) {
})(PlayerInfoStoreKeys || (PlayerInfoStoreKeys = {}));
